import JSZip from 'jszip'
import { generateSalesMaterialUtil, MediaType } from '../../../utils/mediaGenerator'
import { copyZipFilesToMaster } from './zipHelpers'
import { Booklet } from '../../../../../types/generated.types'
import { BookletFolder } from '../../../utils/bookletFolderUtils'

interface GeneratePosterRollupParams {
  associationBooklets: Booklet[]
  associationId: string
  generateSalesMaterialMutation: any
  generatePoster: boolean
  generateRollup: boolean
}

/**
 * Generates poster and/or rollup materials and adds them to master ZIP
 */
export const generatePosterRollup = async ({
  associationBooklets,
  associationId,
  generateSalesMaterialMutation,
  generatePoster,
  generateRollup
}: GeneratePosterRollupParams): Promise<{ posterZip?: JSZip; rollupZip?: JSZip }> => {
  let posterZip: JSZip | undefined
  let rollupZip: JSZip | undefined

  // Generate poster if requested
  if (generatePoster) {
    try {
      const result = await generateSalesMaterialUtil(
        associationBooklets,
        associationId,
        MediaType.POSTER,
        generateSalesMaterialMutation
      )
      posterZip = result.zip
    } catch (error) {
      console.error('Error generating posters:', error)
    }
  }

  // Generate rollup if requested
  if (generateRollup) {
    try {
      const result = await generateSalesMaterialUtil(
        associationBooklets,
        associationId,
        MediaType.ROLLUP,
        generateSalesMaterialMutation
      )
      rollupZip = result.zip
    } catch (error) {
      console.error('Error generating rollup:', error)
    }
  }

  return { posterZip, rollupZip }
}

/**
 * Adds poster and rollup ZIPs to master ZIP with correct folder structure
 */
export const addPosterRollupToMaster = async (
  masterZip: JSZip,
  posterZip: JSZip | undefined,
  rollupZip: JSZip | undefined,
  bookletFolders: BookletFolder[]
): Promise<void> => {
  if (posterZip) {
    await copyZipFilesToMaster(posterZip, masterZip, 'Marknadsför häftet/Affisch med QR-kod till föreningens webbshop/', {
      bookletFolders
    })
  }

  if (rollupZip) {
    await copyZipFilesToMaster(rollupZip, masterZip, 'Marknadsför häftet/Rollup/', {
      bookletFolders
    })
  }
}

